import { rem } from 'polished';
import styled from 'styled-components';
import { OfferStyled } from '../OfferStyled';

export const OfferStyledDS = styled(OfferStyled)`
    .offer {
        /* override jsStyle */
        max-width: 100%;
        width: 100%;
        svg {
            width: ${rem(16)} !important;
            height: ${rem(16)} !important;
            margin-top: ${rem(2)};
            g {
                circle,
                line {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
`;
